module.exports = __webpack_public_path__ + "img/peninsula.be5030ca.webp";